module.exports = __webpack_public_path__ + "static/media/team--anthony.bbda71e9.jpg";